export class SignaturePayload {
    datas = new datas();
    options = new SignatureOptions();
    constructor(options: SignatureOptions) {
        this.options = options
    }
}

class datas {
    fullName : string;
    signature?: string;
}

export class SignatureOptions {
    constructor( public delimiters?:SignatureDelimiters) {
    }
}

export class SignatureDelimiters {
     constructor(public start: string, public end: string) {
    }
}